import { render } from "./App.vue?vue&type=template&id=40a3e2f1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=40a3e2f1&scope=true&lang=scss"

import exportComponent from "/home/developer/Рабочий стол/wheather-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__